import type { Action } from 'svelte/action';

interface Options {
	onEnter?: (entry: IntersectionObserverEntry) => void;
	onExit?: (entry: IntersectionObserverEntry) => void;
	options?: IntersectionObserverInit;
}

export const Intersection: Action<HTMLElement, Options> = (node, options) => {
	let entry: IntersectionObserverEntry | undefined;

	function callback(entries: IntersectionObserverEntry[]) {
		entry = entries.find((entry) => entry.target === node);
		if (!entry) return;

		if (entry.isIntersecting) {
			options.onEnter?.(entry);
		}
		if (!entry.isIntersecting) {
			options.onExit?.(entry);
		}
	}

	const observer = new IntersectionObserver(callback, options.options);

	observer.observe(node);
	return {
		destroy() {
			observer.unobserve(node);
			observer.disconnect();
		}
	};
};
